import * as EntityNormalizers from './entityNormalizers';

export function normalizeDefaultClipConfigutaion(data: string): EntityNormalizers.NormalizedSingleEntity<string> {
  return {
    entities: data,
    result: data,
  };
}
